import { Box, Drawer } from "@mui/material";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Cookies, withCookies } from "react-cookie";
import { useSelector } from "react-redux";
import { useHistory, useLocation, withRouter } from "react-router-dom";
import { darkTheme, lightTheme } from "Theme";

const useStyles = makeStyles((theme) => ({
  sidebar: {
    height: "100%",
    padding: 30,

    "& .h-group": {
      marginBottom: 50,
      textAlign: "center",

      "& h2": {
        marginBottom: 10,
      },
    },
    "& .menu-list": {
      counterReset: "line-number",
      "& a": {
        color: "#8595a6",
        textDecoration: "none",
      },
      "& > li": {
        counterIncrement: "list-number",
        "&:before": {
          content: "'0'counter(list-number)'.'",
          marginRight: 5,
          fontWeight: "bold",
          color: "#8595a6",
        },
        "& > a": {
          fontWeight: "bold",
        },
        "&.current": {
          "&:before": {
            color: "#000",
          },
          "& > a": {
            color: "#000",
          },
        },
        "& + li": {
          marginTop: 20,
        },
      },
      "& .depth-02": {
        position: "relative",
        marginTop: 10,
        paddingLeft: 15,

        "& > ul > li": {
          "& .active-menu": {
            color: "#000",
          },
          "& + li": {
            marginTop: 10,
          },
        },
        "&:before": {
          content: "''",
          position: "absolute",
          top: 0,
          left: 0,
          width: 3,
          height: "100%",
          backgroundColor: "#adbdcc",
        },
      },
    },
  },
}));

function Menu(props) {
  const classes = useStyles();
  const history = useHistory();
  let currentPath = useLocation();
  const [menus, setMenus] = useState([]);
  const [open, setOpen] = useState({ bool: false, index: "", id: "" });

  const getMenu = () => {
    fetch(`${process.env.PUBLIC_URL}/data/guide_menu.json`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setMenus(data);
      });
  };

  const handleSidebarClose = () => {
    props.setSidebar(false);
  };

  useEffect(() => {
    getMenu();
  }, []);

  return (
    <Drawer
      anchor="right"
      open={props.sidebar}
      onClose={handleSidebarClose}
      className={"drawer-guide-right "}
    >
      <div className={classes.sidebar}>
        <nav id="nav">
          <div className="menu-cont">
            <div className="h-group">
              <h2>XT-UI Guide</h2>
            </div>
            <ul className="menu-list">
              {menus.map((d1, index) => (
                <li
                  key={index}
                  onClick={() => {
                    setOpen({ bool: true, index: index, id: d1.id });
                  }}
                  className={open.bool && open.index == index ? "current" : ""}
                  // onMouseEnter={() => {
                  //   setOpen({ bool: true, index: index, id: d1.id });
                  // }}
                  // onMouseLeave={() => {
                  //   setOpen({ ...open, bool: false, index: "" });
                  // }}
                >
                  <a
                    href={d1.items[0].id}
                    className={
                      currentPath.pathname.includes(d1.id) ? "active-menu" : ""
                    }
                    onClick={(e) => {
                      e.preventDefault();

                      if (props.location.pathname !== d1.items[0].id) {
                        props.history.push(d1.items[0].id);
                        // registLog(d1.items[0].id);
                      }
                    }}
                  >
                    {d1.value}
                  </a>

                  {open.bool && open.index == index && (
                    <div className="depth-02">
                      <ul>
                        {d1.items.map((d2, idx) => (
                          <li key={idx}>
                            <a
                              href={d2.id}
                              className={
                                currentPath.pathname === d2.id
                                  ? "active-menu "
                                  : ""
                              }
                              onClick={(e) => {
                                e.preventDefault();
                                if (props.location.pathname !== d2.id) {
                                  props.history.push(d2.id);
                                  // registLog(d2.id);
                                }
                                handleSidebarClose();
                              }}
                            >
                              {d2.value}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </nav>
      </div>
    </Drawer>
  );
}

export default withRouter(withCookies(Menu));
